import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import '../stili/ModaleModificaAllenamento.css';

const defaultForm = {
  idCategoria: '',
  dataAllenamento: '',
  oraInizio: '',
  oraFine: '',
  campo: '',
  tipoAllenamento: '',
  idStaffAllenatoreResponsabile: '',
  faseAttivazione: '',
  durataAttivazione: '',
  faseCentrale: '',
  durataCentrale: '',
  faseFinale: '',
  durataFinale: ''
};

export default function ModaleModificaAllenamento({
  open,
  onClose,
  allenamento,
  categorie = [],
  staffList = [],
  tipiAllenamento = [],
  onSave,
  loadingStaff = false,
  loadingCategorie = false
}) {
  const [form, setForm] = useState(defaultForm);

  const normalizeOra = (ora) => {
    if (!ora) return '';
    return String(ora).substring(0, 5);
  };

  useEffect(() => {
    if (!open || !allenamento) return;

    setForm({
      idCategoria: allenamento.idCategoria ?? '',
      dataAllenamento: allenamento.dataAllenamento ?? '',
      oraInizio: normalizeOra(allenamento.oraInizio),
      oraFine: normalizeOra(allenamento.oraFine),
      campo: allenamento.campo ?? '',
      tipoAllenamento: allenamento.tipoAllenamento ?? '',
      idStaffAllenatoreResponsabile: allenamento.idStaffAllenatoreResponsabile ?? '',
      faseAttivazione: allenamento.faseAttivazione ?? '',
      durataAttivazione: allenamento.durataAttivazione ?? '',
      faseCentrale: allenamento.faseCentrale ?? '',
      durataCentrale: allenamento.durataCentrale ?? '',
      faseFinale: allenamento.faseFinale ?? '',
      durataFinale: allenamento.durataFinale ?? ''
    });
  }, [open, allenamento]);

  const handleClose = () => {
    setForm(defaultForm);
    onClose();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validateDurata = (value, label) => {
    if (value === '' || value === null || value === undefined) return;

    const n = Number(value);

    if (Number.isNaN(n) || n <= 0) {
      throw new Error(`${label} deve essere maggiore di 0.`);
    }
  };

  const calcolaMinutiTotali = (oraInizio, oraFine) => {
    const [h1, m1] = oraInizio.split(':').map(Number);
    const [h2, m2] = oraFine.split(':').map(Number);

    return (h2 * 60 + m2) - (h1 * 60 + m1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.dismiss();

    try {
      if (!form.idCategoria) {
        throw new Error('Categoria obbligatoria.');
      }

      if (!form.dataAllenamento) {
        throw new Error('Data allenamento obbligatoria.');
      }

      if (!form.oraInizio) {
        throw new Error('Ora inizio obbligatoria.');
      }

      if (!form.oraFine) {
        throw new Error('Ora fine obbligatoria.');
      }

      if (form.oraFine <= form.oraInizio) {
        throw new Error("L'ora fine deve essere successiva all'ora inizio.");
      }

      validateDurata(form.durataAttivazione, 'Durata attivazione');
      validateDurata(form.durataCentrale, 'Durata fase centrale');
      validateDurata(form.durataFinale, 'Durata fase finale');

      const durataTotaleAllenamento = calcolaMinutiTotali(form.oraInizio, form.oraFine);
      const sommaFasi =
        Number(form.durataAttivazione || 0) +
        Number(form.durataCentrale || 0) +
        Number(form.durataFinale || 0);

      if (sommaFasi > durataTotaleAllenamento) {
        throw new Error('La somma delle durate delle fasi supera la durata totale dell’allenamento.');
      }

      onSave(form);
    } catch (err) {
      toast.warning(err.message || 'Controlla i dati inseriti');
    }
  };

  if (!open) return null;

  return (
    <div className="modal-overlay" onMouseDown={handleClose}>
      <div className="modal-content" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Modifica Allenamento</h3>
          <button
            className="modal-close"
            type="button"
            onClick={handleClose}
            aria-label="Chiudi finestra"
          >
            ✖
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="modal-grid">
            <label className="modal-field">
              <span>Categoria</span>
              <select
                name="idCategoria"
                value={form.idCategoria}
                onChange={handleChange}
                required
                disabled={loadingCategorie}
              >
                <option value="">
                  {loadingCategorie ? 'Caricamento...' : '-'}
                </option>
                {categorie.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nome}
                  </option>
                ))}
              </select>
            </label>

            <label className="modal-field">
              <span>Data</span>
              <input
                type="date"
                name="dataAllenamento"
                value={form.dataAllenamento}
                onChange={handleChange}
                required
              />
            </label>

            <label className="modal-field">
              <span>Ora Inizio</span>
              <input
                type="time"
                name="oraInizio"
                value={form.oraInizio}
                onChange={handleChange}
                required
              />
            </label>

            <label className="modal-field">
              <span>Ora Fine</span>
              <input
                type="time"
                name="oraFine"
                value={form.oraFine}
                onChange={handleChange}
                required
              />
            </label>

            <label className="modal-field">
              <span>Campo</span>
              <input
                type="text"
                name="campo"
                value={form.campo}
                onChange={handleChange}
                placeholder="es. Campo A"
                maxLength={50}
              />
            </label>

            <label className="modal-field">
              <span>Tipo Allenamento</span>
              <select
                name="tipoAllenamento"
                value={form.tipoAllenamento}
                onChange={handleChange}
              >
                <option value="">-</option>
                {tipiAllenamento.map((tipo) => (
                  <option key={tipo} value={tipo}>
                    {tipo}
                  </option>
                ))}
              </select>
            </label>

            <label className="modal-field modal-field-full">
              <span>Allenatore Responsabile</span>
              <select
                name="idStaffAllenatoreResponsabile"
                value={form.idStaffAllenatoreResponsabile}
                onChange={handleChange}
                disabled={loadingStaff}
              >
                <option value="">
                  {loadingStaff ? 'Caricamento...' : '-'}
                </option>
                {staffList.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.label}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="modal-section-title">Struttura Allenamento</div>

          <div className="modal-fasi-grid">
            <div className="modal-fase-box">
              <label className="modal-fase-label" htmlFor="durataAttivazione">
                1. Fase di attivazione
              </label>

              <input
                id="durataAttivazione"
                type="number"
                name="durataAttivazione"
                value={form.durataAttivazione}
                onChange={handleChange}
                placeholder="Durata in minuti"
                min="1"
              />

              <textarea
                id="faseAttivazione"
                name="faseAttivazione"
                value={form.faseAttivazione}
                onChange={handleChange}
                placeholder="Descrivi la fase di attivazione..."
                rows={4}
              />
            </div>

            <div className="modal-fase-box">
              <label className="modal-fase-label" htmlFor="durataCentrale">
                2. Fase centrale
              </label>

              <input
                id="durataCentrale"
                type="number"
                name="durataCentrale"
                value={form.durataCentrale}
                onChange={handleChange}
                placeholder="Durata in minuti"
                min="1"
              />

              <textarea
                id="faseCentrale"
                name="faseCentrale"
                value={form.faseCentrale}
                onChange={handleChange}
                placeholder="Descrivi la fase centrale..."
                rows={5}
              />
            </div>

            <div className="modal-fase-box">
              <label className="modal-fase-label" htmlFor="durataFinale">
                3. Fase finale
              </label>

              <input
                id="durataFinale"
                type="number"
                name="durataFinale"
                value={form.durataFinale}
                onChange={handleChange}
                placeholder="Durata in minuti"
                min="1"
              />

              <textarea
                id="faseFinale"
                name="faseFinale"
                value={form.faseFinale}
                onChange={handleChange}
                placeholder="Descrivi la fase finale..."
                rows={4}
              />
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="modal-btn-secondary" onClick={handleClose}>
              Annulla
            </button>
            <button type="submit" className="modal-btn-primary">
              Salva Modifiche
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}